import React from 'react';
import { Navigate } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';
const ProtectedRoute = ({ children }) => {
    const orgName = sessionStorage.getItem('organizationName');
    const token = sessionStorage.getItem(`${orgName}_token`);
    
    if(!token){
       return <Navigate to='/login'/>;
    }
    else{
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() /1000;

        if (decodedToken.exp <currentTime){
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('adminId');
          return  <Navigate to='/login'/>
        }
        return children;
    }




    // return token ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;